export default __webpack_public_path__ + "static/media/typee.7bcfdd63.png";